import React from "react";

const Wingo: React.FC = () => {
    const handleOpenPanel = () => {
        window.open('https://color.pori420.com/login', '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <div className=" mx-auto space-y-6">
                {/* Header Section */}
                <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                    <h1 className="text-3xl font-bold text-gray-900 mb-2">
                        Wingo
                    </h1>
                    <p className="text-gray-600">
                        Manage your Wingo game settings and configurations
                    </p>
                </div>

                {/* Main Control Panel Card */}
                <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
                    <div className="bg-gradient-to-r from-gray-900 to-gray-800 p-6">
                        <h2 className="text-2xl font-bold text-white">Game Control Panel</h2>
                        <p className="text-gray-300 mt-1">Access the admin dashboard to manage game operations</p>
                    </div>

                    <div className="p-8 flex flex-col items-center justify-center min-h-[400px]">
                        <div className="text-center space-y-6 max-w-md">
                            {/* Icon */}
                            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto">
                                <svg
                                    className="w-10 h-10 text-gray-700"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                </svg>
                            </div>

                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                                    Administrative Access
                                </h3>
                                <p className="text-gray-600">
                                    Click below to access the comprehensive game control panel with full administrative privileges
                                </p>
                            </div>

                            {/* Action Button */}
                            <button
                                onClick={handleOpenPanel}
                                className="inline-flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 active:bg-gray-950 text-white font-medium py-3 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                            >
                                <span>Open Control Panel</span>
                                <svg
                                    className="w-5 h-5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    />
                                </svg>
                            </button>

                            {/* Security Note */}
                            <div className="flex items-start gap-2 text-left bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <svg
                                    className="w-5 h-5 text-gray-600 mt-0.5 flex-shrink-0"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <div className="text-sm">
                                    <p className="font-medium text-gray-900 mb-1">Secure Access</p>
                                    <p className="text-gray-600">
                                        The control panel will open in a new tab. Please ensure you have the necessary credentials to access administrative features.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Quick Info Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                        <h4 className="font-semibold text-gray-900 mb-1">Secure</h4>
                        <p className="text-sm text-gray-600">Protected admin access</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                        <h4 className="font-semibold text-gray-900 mb-1">Real-time</h4>
                        <p className="text-sm text-gray-600">Live game monitoring</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                        <h4 className="font-semibold text-gray-900 mb-1">Centralized</h4>
                        <p className="text-sm text-gray-600">All controls in one place</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Wingo;